import React from 'react';

const SocialProof = () => {
  return (
    <div>&nbsp;</div>
  );
};

export default SocialProof;
